import React, { Component } from 'react';

import '../css/politicadatos.css'

import logogr from '../img/logo-padilla-quienes.svg'

class politicadatos extends Component {
  render() {
    return (
      <div className="container mt-4">

        <div className="row no-gutters">

          <div className="logoquienestodo container col-lg">
            <div className="row align-items-center p-lg-5 pt-5 pb-5">
              <div className="logocontenedor col-12">
                <img className="logoquienes" src={logogr} alt=""/>
              </div>

              <div className="textologo col-12">
              Política de Datos de Ferretería Padilla <br/> 
              </div>
            </div>
          </div>

          <div className="textoquienestodo container col-lg">
            <div className="row align-items-center no-gutters p-5">
              <div className="tituloquienes col-12 pb-3">
              1. Introducción
              </div>
              <div className="textoquienes col-12">
                <p>Ferretería Padilla, tu mejor opción al momento de construir.</p>
                <p>La Política de Datos de Ferretería Padilla establece los principios y directrices para la gestión responsable de la información en nuestra empresa. Esta política garantiza la confidencialidad, integridad y disponibilidad de los datos, promoviendo la toma de decisiones informadas y el cumplimiento de las regulaciones aplicables.</p>
              </div>
            </div>
          </div>

        </div>

      </div>
    )
  }
}

export default politicadatos;
